var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 7,
    viewBox: "0 0 4 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.65702 0.392785C3.46664 0.202405 3.15797 0.202405 2.96759 0.392785L0.20509 3.15529C0.0147095 3.34567 0.0147095 3.65433 0.20509 3.84471L2.96759 6.60721C3.15797 6.7976 3.46664 6.7976 3.65702 6.60721C3.8474 6.41683 3.8474 6.10817 3.65702 5.91779L1.23923 3.5L3.65702 1.08221C3.8474 0.891834 3.8474 0.583166 3.65702 0.392785Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevBlack);
export default __webpack_public_path__ + "static/media/prev-black.ef31d025bc3fcb3eeab151b32fa44c34.svg";
export { ForwardRef as ReactComponent };